import React from "react";
import mfaStyles from "../../../assets/css/modules/containers/MarkettingMfaSSOcontainer.css";

export default ({ children, mfa, mfaDocument }) => (
  <div className={mfaStyles.background}>
    <div className={mfaStyles.bgimg}>
      <div className={mfaStyles.bgimginner} />
    </div>
    <div className={mfaStyles.overlay} />
    <div className={"container "+ mfa ? mfaStyles.MFAleftparentContainer:mfaStyles.MFAparentContainer}>
      <div className="row">
        <div className="col-sm-12">
          <div
            className={
              "col-md-10 offset-md-1 col-lg-6 offset-lg-3 " +
              (mfa? mfaStyles.mfashadowBorder : mfaDocument? mfaStyles.documentShadowBorder:mfaStyles.shadowBorder) +
              " " +
              mfaStyles.ssocontainer
            }
          >
            <div className={mfa? mfaStyles.MFAElderchildrenContainer:mfaStyles.MFAchildrenContainer}>{children}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
);
